import { render, staticRenderFns } from "./LsError.vue?vue&type=template&id=4ae03b67&scoped=true&"
import script from "./LsError.vue?vue&type=script&lang=js&"
export * from "./LsError.vue?vue&type=script&lang=js&"
import style0 from "./LsError.vue?vue&type=style&index=0&id=4ae03b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae03b67",
  null
  
)

export default component.exports